var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"allBox"},[(_vm.currentCom)?_c(_vm.currentCom,{tag:"component",attrs:{"type":_vm.type,"reasons":_vm.reasons,"authStatus":_vm.authStatus,"selectBankName":_vm.selectBankName},on:{"changeComp":_vm.changeComp}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }